/**
 * Static option lists for the affiliate list FilterBuilder.
 * Values mirror legacy `modules/Affiliate/constants` so the backend
 * receives the same slugs unchanged.
 */
import type { FilterOption } from '@vnetwork/ui/data';

export const AFFILIATE_STATUS_OPTIONS: FilterOption[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'active', label: 'Active' },
  { value: 'suspended', label: 'Suspended' },
  { value: 'inactive', label: 'Inactive' },
];

export const AFFILIATE_TIER_OPTIONS: FilterOption[] = [
  { value: 'standard', label: 'Standard' },
  { value: 'silver', label: 'Silver' },
  { value: 'gold', label: 'Gold' },
  { value: 'platinum', label: 'Platinum' },
];
